import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { PackSetting } from '~/models/administration/packSettings';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class PackSettingsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.adminStock);
  }

  getPackSetting() {
    return this.http.get<PackSetting>(this._url());
  }

  updatePackSettings(model: any) {
    return this.client.put(this._url(), model);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/PackSettings${v}`);
  }
}
